import script from "./SkiAreaStats.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkiAreaStats.vue?vue&type=script&setup=true&lang=ts"

import "./SkiAreaStats.vue?vue&type=style&index=0&id=342b8423&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-342b8423"]])

export default __exports__